import { render, staticRenderFns } from "./TextWithHeadlinePanel.vue?vue&type=template&id=d9b8e63a&scoped=true&"
import script from "./TextWithHeadlinePanel.vue?vue&type=script&lang=ts&"
export * from "./TextWithHeadlinePanel.vue?vue&type=script&lang=ts&"
import style0 from "./TextWithHeadlinePanel.vue?vue&type=style&index=0&id=d9b8e63a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b8e63a",
  null
  
)

export default component.exports